const startManagedRemoteRunStream = ({ activeRunStateByRunId, threadId, runId, state, authToken, authTokenInput = null, assistantEventId = null, eventAlias = null, remoteStreamOwner = 'explicit', backfillBeforeConnect = false, shouldAttachRemoteRunStream, emitThreadRunState, backfillEventsFromSeq, streamRemoteRunLoop, resolveAuthTokenForReconnect, onStreamFailure = null } = {}) => {
  const normalizedThreadId = String(threadId || '').trim();
  const normalizedRunId = String(runId || '').trim();
  const normalizedAuthToken = String(authToken || '').trim();
  const normalizedState =
    String(state || '')
      .trim()
      .toLowerCase() || 'queued';

  if (!normalizedThreadId || !normalizedRunId) {
    return {
      attached: false,
      reason: 'missing_required_fields'
    };
  }

  if (typeof shouldAttachRemoteRunStream !== 'function' || !shouldAttachRemoteRunStream(normalizedState)) {
    return {
      attached: false,
      reason: 'run_not_attachable'
    };
  }

  if (!activeRunStateByRunId || typeof activeRunStateByRunId?.has !== 'function' || activeRunStateByRunId.has(normalizedRunId)) {
    return {
      attached: false,
      reason: 'run_already_attached'
    };
  }

  if (typeof activeRunStateByRunId?.entries === 'function') {
    for (const [activeRunId, activeRunState] of activeRunStateByRunId.entries()) {
      if (String(activeRunId || '').trim() === normalizedRunId) {
        continue;
      }

      if (String(activeRunState?.threadId || '').trim() !== normalizedThreadId) {
        continue;
      }

      if (typeof activeRunState?.controller?.abort === 'function') {
        activeRunState.controller.abort();
      }

      activeRunStateByRunId.delete(activeRunId);
    }
  }

  emitThreadRunState({
    threadId: normalizedThreadId,
    runId: normalizedRunId,
    state: normalizedState
  });

  const streamController = new AbortController();
  activeRunStateByRunId.set(normalizedRunId, {
    threadId: normalizedThreadId,
    runId: normalizedRunId,
    controller: streamController,
    remote: true,
    remoteStreamOwner,
    ...(eventAlias && typeof eventAlias === 'object' ? { eventAlias } : {})
  });

  (async () => {
    try {
      if (backfillBeforeConnect) {
        await backfillEventsFromSeq({
          threadId: normalizedThreadId,
          authToken: normalizedAuthToken
        });
      }

      const streamRes = await streamRemoteRunLoop({
        threadId: normalizedThreadId,
        runId: normalizedRunId,
        assistantEventId,
        authToken: normalizedAuthToken,
        resolveAuthTokenForReconnect,
        signal: streamController.signal
      });

      if (!streamRes?.success && !streamRes?.canceled && typeof onStreamFailure === 'function') {
        await onStreamFailure({
          threadId: normalizedThreadId,
          runId: normalizedRunId,
          state: normalizedState,
          authToken: normalizedAuthToken,
          authTokenInput,
          assistantEventId,
          streamResult: streamRes
        });
      }
    } finally {
      const activeRunState = activeRunStateByRunId.get(normalizedRunId);

      if (activeRunState?.controller === streamController) {
        activeRunStateByRunId.delete(normalizedRunId);
      }
    }
  })();

  return {
    attached: true,
    reason: 'attached'
  };
};

export default startManagedRemoteRunStream;
